import { DragOverlay, useDndContext } from '@dnd-kit/core';
import { createPortal } from 'react-dom';
import { Draggable } from './draggable';

export const DragItem = () => {
	const { active } = useDndContext();

	return createPortal(
		<DragOverlay dropAnimation={null}>
			<Draggable>
				<div className="flex gap-1 items-center justify-between hover:bg-gray-100 rounded-md p-2 cursor-default group z-100 relative">
					<div>
						<Draggable.Title>{active?.data.current?.title}</Draggable.Title>
						<Draggable.Info>{active?.data.current?.subtitle}</Draggable.Info>
					</div>
				</div>
			</Draggable>
		</DragOverlay>,
		document.body,
	);
};
